import { render, staticRenderFns } from "./MyNotes.vue.js?vue&type=template&id=67427241&scoped=true!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./MyNotes.vue?vue&type=template&id=67427241&scoped=true"
import script from "./MyNotes.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./MyNotes.vue?vue&type=script&lang=js"
export * from "./MyNotes.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./MyNotes.vue?vue&type=script&lang=js"
import style0 from "./MyNotes.vue.css?vue&type=style&index=0&id=67427241&prod&scoped=true&lang=css!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./MyNotes.vue?vue&type=style&index=0&id=67427241&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67427241",
  null
  
)

export default component.exports